import React from 'react';
import { useTranslation } from 'react-i18next';
import { Section, SectionTitle, Typography, List } from 'common/components';
import { ShieldCheckIcon, LockIcon, LeroyMerlinStoreIcon } from '@fronton/icons-react';
import {
  headerSection,
  headerContent,
  headerText,
  headerTitle,
  headerListItem,
  headerListIcon,
} from './services-header-section-styles';

export const ServicesHeaderSection = () => {
  const { t } = useTranslation();

  return (
    <Section className={headerSection}>
      <SectionTitle className={headerTitle} as="h1">
        {t('header.title')}
      </SectionTitle>
      <div className={headerContent}>
        <Typography className={headerText} variant="l" size="body_short">
          {t('header.description')}
        </Typography>
        <List>
          <li className={headerListItem}>
            <ShieldCheckIcon className={headerListIcon} type="fill" size="l" color="#1CAFD4" />
            <Typography variant="m" size="body_long">
              {t('header.item-first')}
            </Typography>
          </li>
          <li className={headerListItem}>
            <LockIcon className={headerListIcon} type="fill" size="l" color="#1CAFD4" />
            <Typography variant="m" size="body_long">
              {t('header.item-second')}
            </Typography>
          </li>
          <li className={headerListItem}>
            <LeroyMerlinStoreIcon className={headerListIcon} type="fill" size="l" color="#1CAFD4" />
            <Typography variant="m" size="body_long">
              {t('header.item-third')}
            </Typography>
          </li>
        </List>
      </div>
    </Section>
  );
}
